import { useState, useEffect } from 'react';
import AOS from "aos"
import { ChevronLeft, ChevronRight } from 'lucide-react';
import timeline1 from '../../assets/images/timeline1.jpg'
import timeline2 from '../../assets/images/timeline2.jpg'
import timeline3 from '../../assets/images/timeline3.jpg'
import timeline4 from '../../assets/images/timeline4.jpg'
import timeline5 from '../../assets/images/timeline5.jpg'
import timeline6 from '../../assets/images/timeline6.jpg'
import timeline7 from '../../assets/images/timeline7.jpg'
import timeline8 from '../../assets/images/timeline8.jpg'
import timeline9 from '../../assets/images/timeline9.jpg'
import "aos/dist/aos.css"
const TimelineCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  const timelineData = [
    {
      year: "2012-13",
      title: "The Foundation Year",
      description: "Started production of LED TV, Tablet PC at Rudrapur Plant",
      image:timeline1
    },
    {
      year: "2013-14",
      title: "Diversification Era",
      description: "Started production of Smartphones, Tablet PCs.",
      image: timeline2
    },
    {
      year: "2014-15",
      title: "Global Outreach",
      description: "Started production of backward integration of LED TV, and 3G/4G Internet dongle Speakers & Sound Bars",
      image: timeline3
    },
    {
      year: "2015-16",
      title: "Hyderabad Milestone",
      description: "New Factory at Hyderabad",
      image:timeline4
    },
    {
      year: "2016-17",
      title: "Scaling New Heights",
      description: "New Factory at Bhiwadi",
      image: timeline5
    },
    {
      year: "2017-18",
      title: "Automation Boost",
      description: "Addition of high-speed SMT and wave soldering lines",
      image:timeline6
    },
    {
      year: "2018-20",
      title: "Revolutionary Integration",
      description: "Moulding machine of capacity 160/250/650T in phase -1",
      image:timeline7
    },
    {
      year: "2020-23",
      title: "Market Leadership",
      description: "Air-conditioner, Press shop, HE & Paint shop, TWS & Smartwatch",
      image:timeline8
    },
    {
      year: "2024",
      title: "Future Forward",
      description: "New Factory at Greater Noida",
      image: timeline9
    },
  ];
  

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
      setIsTablet(window.innerWidth >= 640 && window.innerWidth < 1024);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNext = () => {
    if (!isAnimating && activeIndex < timelineData.length - 1) {
      setIsAnimating(true);
      setActiveIndex(prev => prev + 1);
    }
  };

  const handlePrev = () => {
    if (!isAnimating && activeIndex > 0) {
      setIsAnimating(true);
      setActiveIndex(prev => prev - 1);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAnimating(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [activeIndex]);

  const getSlidePercentage = () => {
    if (isMobile) return 100; // 1 card
    if (isTablet) return 50;  // 2 cards
    return 33.33;            // 3 cards
  };

  return (
    <div className="w-full max-w-6xl mx-auto px-4 py-8" >
      <h2 className="text-4xl font-bold text-center text-dark-500 mb-12">Our Journey</h2>
      
      {/* Timeline container */}
      <div className="relative mb-12">
        {/* Base line */}
        <div className="absolute left-0 right-0 h-0.5 bg-gray-200 top-4" />
        
        {/* Progress line */}
        <div 
          className="absolute h-0.5 bg-dark-500 top-4 transition-all duration-500"
          style={{ 
            left: '0',
            width: `${(activeIndex / (timelineData.length - 1)) * 100}%`
          }}
        />

        {/* Timeline indicators */}
        <div className="flex justify-between items-center relative">
          {timelineData.map((item, index) => (
            <div
              key={item.year}
              className="flex flex-col items-center cursor-pointer group"
              onClick={() => !isAnimating && setActiveIndex(index)}
            >
              <div 
                className={`h-6 w-6 rounded-full border-2 transition-all duration-300 flex items-center justify-center
                  ${index === activeIndex 
                    ? 'border-dark-500 bg-orange-500' 
                    : index < activeIndex 
                      ? 'border-black-500 bg-orange-500' 
                      : 'border-gray-300 bg-white'
                  }`}
              >
                <div className={`h-2 w-2 rounded-full ${index <= activeIndex ? 'bg-white' : 'bg-gray-300'}`} />
              </div>
              <span className={`mt-2 text-[10px] sm:text-xs font-medium transition-all duration-300 transform group-hover:scale-110
                ${index === activeIndex 
                  ? 'text-orange-500' 
                  : index < activeIndex 
                    ? 'text-rose-400' 
                    : 'text-gray-500'
                }`}>
                {item.year}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Cards container */}
      <div className="relative overflow-hidden ">
        <div 
          className="flex transition-transform duration-500 ease-in-out "
          style={{ 
            transform: `translateX(-${activeIndex * getSlidePercentage()}%)`
          }}
        >
          {timelineData.map((item, index) => (
            <div
              key={index}
              className={`flex-shrink-0 px-2 ${
                isMobile ? 'w-full' : isTablet ? 'w-1/2' : 'w-1/3'
              }`}
            >
              <div className={`bg-white rounded-xl  overflow-hidden transition-all duration-500 border h-full
                ${index === activeIndex ? 'opacity-100 scale-100' : 'opacity-40 scale-100'}`}
              >
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-48 sm:h-56 md:h-64  object-cover"
                />
                <div className="p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl font-bold text-dark-500 mb-2">{item.title}</h3>
                  <p className="text-sm text-gray-600">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
         
        </div>

        {/* Navigation buttons - Hidden on mobile */}
        <button
          onClick={handlePrev}
          disabled={activeIndex === 0}
          className="hidden sm:block absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 bg-white p-2 rounded-full shadow-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
        >
          <ChevronLeft className="w-6 h-6 text-gray-600" />
        </button>
        <button
          onClick={handleNext}
          disabled={activeIndex === timelineData.length - 1}
          className="hidden sm:block absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 bg-white p-2 rounded-full shadow-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
        >
          <ChevronRight className="w-6 h-6 text-gray-600" />
        </button> <br/><br/><br/>
      </div>
      
      {/* Mobile navigation buttons */}
      <div className="flex justify-center gap-4 mt-6 sm:hidden">
        <button
          onClick={handlePrev}
          disabled={activeIndex === 0}
          className="bg-white p-2 rounded-full shadow-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
        >
          <ChevronLeft className="w-6 h-6 text-gray-600" />
        </button>
        <button
          onClick={handleNext}
          disabled={activeIndex === timelineData.length - 1}
          className="bg-white p-2 rounded-full shadow-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
        >
          <ChevronRight className="w-6 h-6 text-gray-600" />
        </button>
      </div>
      
      <div className="h-12" /> {/* Bottom spacing */}
    </div>
  );
};

export default TimelineCarousel;